import { isObject } from "underscore";
import { useBOMStore } from "../../../../hooks/bom";

export default function useTabDisplayStatus(api_fetch_type) {
    const [{ bom_detail_by_bom_id_type }, { }, { }] = useBOMStore();
    const displayStatus = () => {
        if (bom_detail_by_bom_id_type[api_fetch_type] !== undefined &&
            bom_detail_by_bom_id_type[api_fetch_type].records !== undefined &&
            isObject(bom_detail_by_bom_id_type[api_fetch_type].records) && Object.entries(bom_detail_by_bom_id_type[api_fetch_type].records).length > 0) {
            return true;
        }
        return false;
    };

    return [displayStatus];
}
